// extracted by mini-css-extract-plugin
module.exports = {"Clock":"Clock_Clock__3dHhC"};